import { render, staticRenderFns } from "./plane-spinner.vue?vue&type=template&id=7161b3c0&scoped=true&"
import script from "./plane-spinner.vue?vue&type=script&lang=js&"
export * from "./plane-spinner.vue?vue&type=script&lang=js&"
import style0 from "./plane-spinner.vue?vue&type=style&index=0&id=7161b3c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7161b3c0",
  null
  
)

export default component.exports